import React from 'react';
import styles from './FullPageLoader.module.css';

const FullPageLoader = () => {
    return (
        <div className={styles.FullPageLoader}>
            <div className={styles.LoaderRing}>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    );
};

export { FullPageLoader };
